module.exports = __webpack_public_path__ + "img/39.bce35938.png";